import React from 'react'
import { FlatList, Linking, Platform, View } from 'react-native'
import PropTypes from 'prop-types'

import { VFText } from '@vfgroup-oneplatform/foundation/Components'

import AppointmentCard from '../AppointmentCard'

import styles from './AppointmentsList.Styles'

const AppoinmentCardItem = ({
  item,
  index,
  appointments,
  formatAppointmentDate,
  withCancelBookingButton,
  onCancelBookingPress,
  withChangeBookingPress,
  onChangeBookingPress,
  isStoreLoading,
  store,
  services
}) => {

  return (
    <View style={styles.appointmentCard}>
      <AppointmentCard
        key={`AppointmentCard-${index}`}
        formatAppointmentDate={formatAppointmentDate}
        onGetStoreDirectionsPress={onGetStoreDirectionsPress}
        withCancelBookingButton={withCancelBookingButton}
        onCancelBookingPress={onCancelBookingPress}
        withChangeBookingPress={withChangeBookingPress}
        onChangeBookingPress={onChangeBookingPress}
        {...item}
        store={store}
        isStoreLoading={isStoreLoading}
        service={{
          ...item?.service,
          title: services.find(el => el.serviceIcon === item?.service?.image)?.title
        }}
      />
    </View>
  )
}

const onGetStoreDirectionsPress = (longitude, latitude) => {
  const scheme = Platform.select({ android: 'geo:', ios: 'maps:' })
  const url = `${scheme}${latitude},${longitude}`

  Linking.openURL(url)
}

const AppointmentsList = ({
  appointments,
  formatAppointmentDate,
  withCancelBookingButton,
  onCancelBookingPress,
  withChangeBookingPress,
  onChangeBookingPress,
  services
}) => {

  return (
    <View style={styles.container} >
      <FlatList
        style={styles.flatListStyle}
        contentContainerStyle={styles.contentContainerStyle}
        data={appointments}
        keyExtractor={(item, index) => index}
        renderItem={({ item, index }) => {
          return (
            <AppoinmentCardItem
              key={index}
              item={item}
              index={index}
              appointments={appointments}
              formatAppointmentDate={formatAppointmentDate}
              withCancelBookingButton={withCancelBookingButton}
              onCancelBookingPress={onCancelBookingPress}
              withChangeBookingPress={withChangeBookingPress}
              onChangeBookingPress={onChangeBookingPress}
              isStoreLoading={false}
              store={{}}
              services={services}
            />
          )
        }}
        // ListHeaderComponent={() => <VFText i18nKey="Historiku" style={styles.title} />}
        showsVerticalScrollIndicator={false}
      />
    </View>
  )
}

AppointmentsList.propTypes = {
  appointments: PropTypes.arrayOf(
    PropTypes.shape({
      serviceType: PropTypes.string,
      image: PropTypes.shape({ uri: PropTypes.string }),
      store: PropTypes.shape({
        name: PropTypes.string,
        address: PropTypes.shape({
          name: PropTypes.string,
        }),
        contactInfo: PropTypes.shape({
          email: PropTypes.string,
          phoneNumber: PropTypes.string,
        }),
      }).isRequired,
      date: PropTypes.shape({
        date: PropTypes.string,
        duration: PropTypes.string,
      }).isRequired,
    }),
  ).isRequired,
  formatAppointmentDate: PropTypes.func,
  withCancelBookingButton: PropTypes.bool,
  onCancelBookingPress: PropTypes.func,
  withChangeBookingPress: PropTypes.bool,
  onChangeBookingPress: PropTypes.func,
  getLocationData: PropTypes.func
}

export { onGetStoreDirectionsPress }
export default AppointmentsList
